const webinarHero = $('#hero-section');
const heroCover = webinarHero.find('.webinar-cover');
const heroCoverBtn = webinarHero.find('.button-parent');

const webinarHeroIn = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const heroTitle = $('.webinar-hero-section-title');

  const sectionInTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
    },
  });


  if (isDesktop()) {
    toggleCardAnimation(false, true);
    /*
    sectionInTL.add(
      animateSectionTopperIn({
        sectionParent: webinarHero,
        gradientConfig: gradientConfig,
      }).play(),
      0.5
    );
    */
    sectionInTL.add(addMediumTitleAnimation(heroTitle, 150, 1, 0.15).play(), 0.7);
    sectionInTL.add(() => {
      toggleCardAnimation(true);
    }, 1.4);
  }

  sectionInTL.add(elementInAnimationYWOpacity(heroCover, '15vw', 0, 1, 1.37).play(), 0.5);
  sectionInTL.add(addBtnAnimation(heroCoverBtn, 50).play(), 0.5);
  sectionInTL.add(headerAnimation(true, 0.6, 0.01).play(), 1.8);

  return sectionInTL;
};

$('.page-overflow').css('background-color', 'var(--cheerful-whisper-100)');
$(window).on('load', () => {
  const [nav] = performance.getEntriesByType('navigation');
  const heroTL = webinarHeroIn();
  pageIn(heroTL, nav);
  if(window.location.href.includes('en-international')){
    initRegionChange('us', window.location.href);
  }
});
